import { styled } from 'linaria/react';
import { FONTS } from 'styles/constants';

export const StyledTitle = styled.span`
  padding: 32px 0 16px;
  font: 400 22px/130% ${FONTS.primary};
`;
